import type { State } from '../../state/types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { ReleaseBar } from '../../state/ui/main/tabs/roadmap/timeline/release-bar/types';

export const getReleaseBarState = (state: State) => state.ui.Main.Tabs.Roadmap.Timeline.ReleaseBar;
